<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">
      Recharge Fields Update History: {{ $route.params.code }}
    </h3>
    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="clear_filter()"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>
    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header"
      :busy="working"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template slot="cell(date_created)" slot-scope="{ index, item }">
        <date-display
          :value="item.date_created"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>

      <template slot="cell(field_name)" slot-scope="{ index, item }">
        <default-display :value="item.field_name"></default-display>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.modified_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(new_value)" slot-scope="{ index, item }">
        <default-display :value="item.new_value"></default-display>
      </template>
      <template slot="cell(username)" slot-scope="{ index, item }">
        <default-display :value="item.username"></default-display>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'field_history.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>
<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("FieldHistory", "field_history"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("FieldHistory"),
    CreateCodeTableFetchMixin([]),
  ],
  watch: {
    checkListOptions(oldData, newData) {
      // watch the data in list_options
      console.log("this.list_options", this.list_options);
    },
  },
  data: function () {
    return {
      list_options_new: {
        //Filter
        filter: "",
        limit: parseInt(this.$route.query.limit || 10),
        offset: parseInt(this.$route.query.offset || 0),
        order: this.$route.query.order || "desc",
        ordering: "",
        q: this.$route.query.q || "",
        rechargeId: this.$route.params.rechargeId,
        searchField: this.$route.query.searchField || "",
        sort: this.$route.query.sort || "id",
      },
      schemaModel: cleanUpModel(
        schema.FieldHistory,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.FieldHistory),

      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        username: { label: "Who" },
      },
    };
  },

  computed: {
    clear_filter() {
      this.list_options.filter = "";
      this.list_options.q = "";
      this.list_options.searchField = "";
    },
    checkListOptions() {
      this.list_options = this.list_options_new;
      return this.list_options;
    },
    options() {
      return {};
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "field_name",
        "new_value",
        "date_created",
        "username",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
  },
};
</script>
